import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { tabExitEventTracker } from './exit';
import { heartbeatEventTracker } from './heartbeat';
import { scrollEventTracker } from './scroll';
import { userClickTracker } from './user-click';
export var trackers = {
  scroll: scrollEventTracker,
  heartbeat: heartbeatEventTracker,
  exit: tabExitEventTracker,
  userClick: userClickTracker
};

/**
 * Returns the options for a given tracker, based on the provided tracking options
 *
 * The trackingOptions might either be:
 * - undefined, in which case the tracker is enabled with default options
 * - a boolean [true] which enables the tracker with default options
 * - a boolean [false] which disables the tracker
 * - an object with the options for the tracker
 *
 * @param trackingOptions The tracking options provided by the user
 * @param name The name of the tracker
 */
function getTrackerOptions(trackingOptions, name) {
  // If the tracker is not explicitly disabled as boolean false, it is enabled by default
  var enabled = trackingOptions === true || (trackingOptions === null || trackingOptions === void 0 ? void 0 : trackingOptions[name]) === undefined || trackingOptions[name] !== false; // If the tracker is enabled, but no options are provided, use an empty object

  var options = typeof (trackingOptions === null || trackingOptions === void 0 ? void 0 : trackingOptions[name]) !== 'boolean' ? trackingOptions === null || trackingOptions === void 0 ? void 0 : trackingOptions[name] : undefined;
  return {
    enabled: enabled,
    options: options
  };
}

export function initialize(trackingOptions) {
  if (trackingOptions === false) {
    return;
  }

  for (var _i = 0, _Object$entries = Object.entries(trackers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        tracker = _Object$entries$_i[1];

    var _getTrackerOptions = getTrackerOptions(trackingOptions, name),
        enabled = _getTrackerOptions.enabled,
        options = _getTrackerOptions.options;

    if (!enabled) {
      continue;
    }

    tracker(options);
  }
}